import { ArtworksCreate } from './ArtworksCreate'
import { ArtworksEdit } from './ArtworksEdit'
import { ArtworksList } from './ArtworksList'
import { ArtworksShow } from './ArtworksShow'

export const artworks = {
  create: ArtworksCreate,
  edit: ArtworksEdit,
  list: ArtworksList,
  show: ArtworksShow,
}
